
export interface IHasTotalPrice {
    getTotalPrice(): number | null
    setTotalPrice(totalPrice: number): void
}

function hasTotalPrice<TBase extends Constructor>(Base: TBase) {
    return class extends Base implements IHasTotalPrice {
        private totalPrice: number | null = null

        constructor(...args: any[]) {
            super(...args);
        }

        public getTotalPrice(): number | null {
            return this.totalPrice
        }
        public setTotalPrice(totalPrice: number): void {
            this.totalPrice = totalPrice
        }
    };
}

export default hasTotalPrice